import { Question } from '../types';

export const questions: Question[] = [
  // Financial Management
  {
    id: 'fin1',
    category: 'financial',
    text: 'Our budgeting and financial tracking processes are streamlined and accurate',
    tooltip: 'Efficient financial processes reduce errors and improve decision-making'
  },
  {
    id: 'fin2',
    category: 'financial',
    text: 'We maintain accurate records of restricted and designated funds and regularly compare actual expenses to budgeted amounts',
    tooltip: 'Regular tracking and comparison ensures proper fund management and budget adherence'
  },
  {
    id: 'fin3',
    category: 'financial',
    text: 'We have established a concise system for tracking purchases and vendors',
    tooltip: 'Efficient purchase tracking improves financial management and vendor relationships'
  },
  {
    id: 'fin4',
    category: 'financial',
    text: 'We process payroll and expense reimbursements promptly and efficiently',
    tooltip: 'Timely processing maintains good relationships with staff and volunteers'
  },
  {
    id: 'fin5',
    category: 'financial',
    text: 'We have an efficient system for processing, recording, and categorizing donations',
    tooltip: 'Efficient donation management ensures accurate records and timely acknowledgments'
  },

  // Communications & Media
  {
    id: 'com1',
    category: 'communications',
    text: 'We maintain consistent visual branding and engaging communication across all platforms (social media, email, website)',
    tooltip: 'Consistent communication builds engagement and keeps your community informed'
  },
  {
    id: 'com2',
    category: 'communications',
    text: 'We create and distribute high-quality multimedia content (sermons, podcasts, videos) in a timely manner',
    tooltip: 'Quality content engages your audience across multiple channels'
  },
  {
    id: 'com3',
    category: 'communications',
    text: 'We utilize our sermons for weekly discipleship resources and formation',
    tooltip: 'Effective sermon utilization enhances discipleship and spiritual growth'
  },
  {
    id: 'com4',
    category: 'communications',
    text: 'Our church knows what is upcoming and knows where to find details easily',
    tooltip: 'Clear communication channels help members stay informed and engaged'
  },
  {
    id: 'com5',
    category: 'communications',
    text: 'We create targeted communications for different ministries and audiences',
    tooltip: 'Targeted messaging ensures relevant information reaches the right people'
  },

  // Technology & Data Management
  {
    id: 'tech1',
    category: 'technology',
    text: 'Our team has a clear, centralized system for tracking all tasks and projects',
    tooltip: 'Centralized tracking improves visibility and coordination'
  },
  {
    id: 'tech2',
    category: 'technology',
    text: 'We have documented processes for all major administrative tasks and procedures',
    tooltip: 'Documentation ensures consistency and helps with training'
  },
  {
    id: 'tech3',
    category: 'technology',
    text: 'Our meetings consistently start and end on time with clear outcomes and follow-up',
    tooltip: 'Efficient meetings respect time and improve productivity'
  },
  {
    id: 'tech4',
    category: 'technology',
    text: 'Task deadlines are consistently met without last-minute rushes or stress',
    tooltip: 'Meeting deadlines smoothly indicates good planning and execution'
  },
  {
    id: 'tech5',
    category: 'technology',
    text: 'We have effective systems for sharing updates and information across ministry teams',
    tooltip: 'Good communication systems keep ministry teams informed and aligned'
  },

  // Administrative Systems
  {
    id: 'admin1',
    category: 'administrative',
    text: 'We effectively use Church Management Software for ministry coordination and tracking',
    tooltip: 'Effective ChMS use improves ministry coordination and data management'
  },
  {
    id: 'admin2',
    category: 'administrative',
    text: 'We maintain accurate and up-to-date records across all databases with minimal duplicate data entry',
    tooltip: 'Accurate records with minimal duplication improve efficiency'
  },
  {
    id: 'admin3',
    category: 'administrative',
    text: 'Our data is consistently backed up and secure across all our systems',
    tooltip: 'Regular backups and security protect important information'
  },
  {
    id: 'admin4',
    category: 'administrative',
    text: 'New staff members can quickly learn and access all necessary technology tools',
    tooltip: 'Easy system adoption indicates good documentation and training'
  },
  {
    id: 'admin5',
    category: 'administrative',
    text: 'We can easily generate reports on key ministry metrics and outcomes',
    tooltip: 'Easy reporting helps track progress and make decisions'
  },

  // People
  {
    id: 'fac1',
    category: 'facilities',
    text: 'We have a structured, intentional process for identifying and developing new leaders within our congregation',
    tooltip: 'Systematic leadership development ensures ministry growth and sustainability'
  },
  {
    id: 'fac2',
    category: 'facilities',
    text: 'Our volunteer recruitment, training, and appreciation systems consistently maintain adequate ministry coverage without burnout',
    tooltip: 'Effective volunteer management ensures sustainable ministry operations'
  },
  {
    id: 'fac3',
    category: 'facilities',
    text: 'We maintain clear role descriptions, performance expectations, and reporting structures for all staff positions',
    tooltip: 'Clear expectations and structure promote accountability and effectiveness'
  },
  {
    id: 'fac4',
    category: 'facilities',
    text: 'Our leadership demonstrates healthy delegation practices, avoiding both micromanagement and abdication of responsibilities',
    tooltip: 'Balanced delegation promotes team growth and operational efficiency'
  },
  {
    id: 'fac5',
    category: 'facilities',
    text: 'We have established boundaries and support systems that promote sustainable work-life balance for our pastoral staff and key leaders',
    tooltip: 'Healthy boundaries prevent burnout and promote long-term ministry effectiveness'
  }
];